import { createIcon } from './create-icon';

export const HomeIcon = createIcon(
  'HomeIcon',
  <>
    <path d="M3 12L12 3l9 9" />
    <path d="M5 10v9a1 1 0 001 1h4v-5h4v5h4a1 1 0 001-1v-9" />
  </>,
);
